import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { showErrorToast } from "../../common/Toast";
import { postUsersConfirm } from "../../lib/service/user-resource";
import { AxiosError } from "axios";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";

interface Props {
  visible: boolean;
  username: string;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleClick: () => void;
}

export const VerifyOtpDialog = (props: Props) => {
  const { login } = useAuth();
  const [otp, setOtp] = useState<string[]>(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState<boolean>(false);
  const [confirmationCode, setconfirmationCode] = useState<string>("");
  const navigate = useNavigate();
  const username = props.username;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) {
      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value;

    if (index < 5 && value) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    }

    setOtp(newOtp);
  };

  const handleVerifyOtp = async () => {
    try {
      setLoading(true);
      const otpAsString = otp.join("");
      const verifyOtp = {
        confirmationCode: otpAsString,
        username,
      };

      const response = await postUsersConfirm(verifyOtp);

      if (response.status >= 400) {
        // Handle 4xx and 5xx errors
        showErrorToast(response.errorMessage);
      } else {
        // It's a successful response (ApiResponse<T>)
        props.setVisible(false);

        const user = { username: username };
        login(user);

        navigate("/profile");
      }
    } catch (error) {
      // Handle other types of errors
      console.error(error);
    }

    setLoading(false);
  };

  const dialogFooter = (
    <div className="flex justify-content-end col-12">
      <Button
        className="w-8rem"
        label="Submit"
        onClick={() => {
          handleVerifyOtp();
          props.setVisible(false);
        }}
      />
    </div>
  );

  return (
    <div>
      {loading && (
        <div className="loading-overlay">
          <ProgressSpinner />
        </div>
      )}
      <div>
        <Dialog
          header="Verify OTP"
          visible={props.visible}
          className="ml-8"
          style={{ width: "500px" }}
          footer={dialogFooter}
          onHide={() => props.setVisible(false)}
        >
          <p className="p-dialog-content text-xl">
            Enter the verification code that was sent to your email
          </p>
          <div className="flex flex-row gap-1 align-items-center w-12">
            {otp.map((digit, index) => (
              <InputText
                className="p-inputtext w-2 m-2"
                style={{ textAlign: "center" }}
                key={index}
                id={`otp-input-${index}`}
                value={digit}
                onChange={(e) => handleChange(e, index)}
                maxLength={1}
              />
            ))}
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default VerifyOtpDialog;
